import React, { FunctionComponent } from 'react';
import { Button } from '@justgiving/react-tracking';
import { useShareContext } from '../../context/ShareContext';
import { useTranslation } from 'react-i18next';

export type TwitterShareProps = {
  className?: string;
  trackingData?: Record<string, any>;
  onClick?: () => void;
};

export const TwitterShare: FunctionComponent<TwitterShareProps> = ({
  className,
  trackingData,
  onClick,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const { shareItems } = useShareContext();

  const clickButton = () => {
    const twitterHref = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
      shareItems.twitter.url,
    )}&text=${encodeURIComponent(shareItems.twitter.message)}`;

    window.open(twitterHref, 'newwindow', 'width=600,height=300');
    if (onClick) {
      onClick();
    }
  };

  return (
    <Button
      className={`jg-btn jg-btn--twitter ${className}`}
      onClick={clickButton}
      type="button"
      trackingData={{
        action_name: 'click',
        subtype: 'share',
        event: 'click',
        event_value: 'twitter',
        ...trackingData,
      }}
    >
      <span className="jg-sr-only">{t('common.shareOn')}</span>
      {t('common.twitter')}
    </Button>
  );
};

export default TwitterShare;
